import React from 'react';
import {useTranslation} from 'react-i18next';
import AppearAfter from './appear.after';
import AnimationInSelect from './animation.in.select';
import {AnimationString, IElementAnimations} from '../../../../incase-domain/common/animationString';
import {IElement} from '../../../../incase-domain/elements';
import SectionTitle from '../../../elements/common/SectionTitle';

interface AnimationFormProps {
    appearAfter: number;
    elementAnimations?: IElementAnimations;
    highlightedElementChangeHandler: {single: (label: keyof IElement, value: unknown) => void};
}

function AnimationForm(props: AnimationFormProps): JSX.Element {
    const {appearAfter, elementAnimations, highlightedElementChangeHandler} = props;
    const {t} = useTranslation();

    const entry = elementAnimations?.entry ?? '';
    const sequence = elementAnimations?.sequence ?? '';

    function updateAnimations(patch: Partial<IElementAnimations>): void {
        highlightedElementChangeHandler.single('elementAnimations', {
            entry: 'sequence' in patch ? '' : patch.entry,
            sequence: 'entry' in patch ? '' : patch.sequence,
        });
    }

    return (
        <div className="l-group--form">
            <SectionTitle label={t('designSidepanel.animation')} />
            <div className="u-flex u-flex-col u-gap-1">
                <AnimationInSelect
                    animationIn={entry}
                    label={t('designSidepanel.animationEntry')}
                    category="entry"
                    highlightedElementChangeHandler={(value) => updateAnimations({entry: value as AnimationString})}
                />

                {entry && (
                    <AppearAfter
                        appearAfter={appearAfter || 0}
                        highlightedElementChangeHandler={(newValue) => highlightedElementChangeHandler.single('appearAfter', newValue)}
                    />
                )}

                <div className="u-mt-2">
                    <AnimationInSelect
                        animationIn={sequence}
                        label={t('designSidepanel.animationSequence')}
                        category="all"
                        highlightedElementChangeHandler={(value) => updateAnimations({sequence: value as AnimationString})}
                    />
                </div>
            </div>
        </div>
    );
}

export default AnimationForm;
